import { render, staticRenderFns } from "./StcvN_ItemsFinish_List.vue?vue&type=template&id=f8a2e938"
import script from "./StcvN_ItemsFinish_List.vue?vue&type=script&lang=js"
export * from "./StcvN_ItemsFinish_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports